export default __webpack_public_path__ + "static/media/coverage-map.d129e227.png";